export enum AppRoutes {
  LOGIN = '/login',
  CUSTOMER_FOCUS = '/customer-focus',
  PERSONALIZED_ENGAGEMENT = '/personalized-engagement',
  SEARCH_HCPS = '/search-hcps',
  MY_HCPS = '/my-hcps',
  PARTNERSCORE_GROUP = '/partner-score',
  PARTNERSCORE = '/partner-score/partner-score',
  CSATSCORE = '/partner-score/customer-satisfaction',
  CESSCORE = '/partner-score/effort-score',
  NPSSCORE = '/partner-score/net-promoter-score',
  HCP_OVERVIEW = '/hcp-overview/:countryCode/:uci',
  HCO_OVERVIEW = '/hco-overview/:countryCode/:id',
  HCP_CLINICAL_TRIAL_DETAILS = '/clinical-trial-id/:trialId',
  DATA_REFRESH_DETAILS = '/data-refresh-details',
  DISCLAIMER_PAGE = '/disclaimer',
  PERFORMANCE_DASHBOARD = '/performance-dashboard',
  HCP_CONFERENCE_ABSTRACT_DETAILS = '/conference-abstract-id/:embaseId',
  CONFERENCE_ONE_PAGER = '/conference-id/:conferenceId',
  CHANNEL_FOCUS_GROUP = '/channel-focus',
  CHANNEL_ALL_CHANNELS = '/channel-focus/all-channels',
  CHANNEL_FOCUS_1_TO_1 = '/channel-focus/1to1visit',
  CHANNEL_FOCUS_EMAIL = '/channel-focus/email',
  CHANNEL_FOCUS_EVENT = '/channel-focus/event',
  CHANNEL_FOCUS_WEBSITE = '/channel-focus/website',
  MANAGE_PREFERENCES = '/manage-preferences',
  MANAGE_PREFERENCES_USER = '/manage-preferences/user',
  MANAGE_PREFERENCES_LANGUAGE = '/manage-preferences/language',
  ACCESS_DENIED = '/access-denied',
  GLOBAL_BENCHMARKING_GROUP = '/global-benchmarking',
  GLOBAL_BENCHMARKING_1_TO_1 = '/global-benchmarking/1to1visits',
  GLOBAL_BENCHMARKING_EMAIL = '/global-benchmarking/email',
  GLOBAL_BENCHMARKING_EVENT = '/global-benchmarking/event',
  GLOBAL_BENCHMARKING_WEBSITE = '/global-benchmarking/website',
  AGGREGATED_CONSENT_GROUP = '/aggregated-consent',
  AGGREGATED_CONSENT_OVERVIEW = '/aggregated-consent/overview',
  AGGREGATED_CONSENT_DIRECT_MAIL = '/aggregated-consent/directmail',
  AGGREGATED_CONSENT_EMAIL = '/aggregated-consent/email',
  AGGREGATED_CONSENT_FACE_TO_FACE = '/aggregated-consent/facetoface',
  AGGREGATED_CONSENT_FAX = '/aggregated-consent/fax',
  AGGREGATED_CONSENT_KAKAOTALK = '/aggregated-consent/kakaotalk',
  AGGREGATED_CONSENT_LINKEDIN = '/aggregated-consent/linkedin',
  AGGREGATED_CONSENT_PHONE = '/aggregated-consent/phone',
  AGGREGATED_CONSENT_REMOTE_ENGAGEMENT = '/aggregated-consent/remoteengagement',
  AGGREGATED_CONSENT_SMS = '/aggregated-consent/sms',
  AGGREGATED_CONSENT_TWITTER = '/aggregated-consent/twitter',
  AGGREGATED_CONSENT_VIBER = '/aggregated-consent/viber',
  AGGREGATED_CONSENT_WHATSAPP = '/aggregated-consent/whatsapp',
  INSIGHTS_GROUP = '/insights',
  INSIGHTS_ANALYSIS = '/insights/analysis',
  INSIGHTS_KPIS = '/insights/kpis',
  AGGREGATED_SCIENTIFIC_INFORMATION_GROUP = '/aggregated-scientific-information',
  AGGREGATED_SCIENTIFIC_INFORMATION_OVERVIEW = '/aggregated-scientific-information/overview',
  AGGREGATED_SCIENTIFIC_INFORMATION_CLINICAL_TRIALS = '/aggregated-scientific-information/clinical-trials',
  AGGREGATED_SCIENTIFIC_INFORMATION_PUBLICATIONS = '/aggregated-scientific-information/publications',
  AGGREGATED_SCIENTIFIC_INFORMATION_CONGRESS_ACTIVITY = '/aggregated-scientific-information/congress-activity',
  COMPETITOR_ANALYSIS_GROUP = '/competitor-analysis',
  COMPETITOR_ANALYSIS = '/competitor-analysis/partner-score',
  COMPETITOR_CSATSCORE = '/competitor-analysis/customer-satisfaction',
  COMPETITOR_CESSCORE = '/competitor-analysis/effort-score',
  COMPETITOR_NPSSCORE = '/competitor-analysis/net-promoter-score',
  SALES_GROUP = '/sales',
  SALES_KEY_INDICATORS = '/sales/key-indicators',
  SALES_REGIONAL_FOCUS = '/sales/regional-focus',
  SALES_COMPETITOR_FOCUS = '/sales/competitor-focus',
}

export const BackwardCompatibilityRedirects: Record<string, AppRoutes> = {
  '/global-benchmarking/1-to-1': AppRoutes.GLOBAL_BENCHMARKING_1_TO_1,
  '/channel-focus/1-to-1': AppRoutes.CHANNEL_FOCUS_1_TO_1,
  '/aggregated-engagement': AppRoutes.CHANNEL_ALL_CHANNELS,
};
